import React from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { observer } from 'mobx-react';
import CheckoutPage from './screens/checkout';
import NotFoundPage from './screens/404';
import CheckoutSuccessPage from './screens/checkout/screens/CheckoutSuccessPage';

function Router() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/">
          <Route
            path=":slug"
            element={<Navigate to=":slug/checkout" replace />}
          />
          <Route path=":slug/checkout" element={<CheckoutPage />} />
          <Route path=":slug/checkout/success/:externalId" element={<CheckoutSuccessPage />} />
          {/* <Route path="user/resetPassword" element={<ResetPasswordPage />} />
          <Route path="user/setPassword/:token" element={<SetPasswordPage />} /> */}
          <Route
            path="*"
            element={<NotFoundPage />}
          />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default observer(Router);
